import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderService } from 'src/app/header/service/header.service';
import * as bootstrap from 'bootstrap';

@Component({
  selector: 'app-modal-esqueceu-senha',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './modal-esqueceu-senha.component.html',
  styleUrl: './modal-esqueceu-senha.component.scss'
})
export class ModalEsqueceuSenhaComponent implements OnInit, OnDestroy {

  @Output() closed = new EventEmitter<void>();

  form: FormGroup;
  isLoading = false;
  submitted = false;
  errorMessage = '';

  private modal!: bootstrap.Modal;
  private headerService = inject(HeaderService);

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      login: ['', [Validators.required]]
    });
  }

  get loginControl() { return this.form.get('login'); }

  ngOnInit() {
    const el = document.getElementById('modalEsqueceuSenha');
    if (el) {
      this.modal = new bootstrap.Modal(el, { backdrop: true, keyboard: true });
      el.addEventListener('hidden.bs.modal', () => {
        this.resetState();
        this.closed.emit();
      });

      this.modal.show();
    }
  }

  ngOnDestroy() {
    this.modal?.dispose();
  }

  close() {
    this.modal?.hide();
  }

  private resetState() {
    this.submitted = false;
    this.isLoading = false;
    this.errorMessage = '';
    this.form.reset();
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.headerService.forgotPassword({ login: this.form.value.login }).subscribe({
      next: () => {
        this.isLoading = false;
        this.submitted = true;
      },
      error: () => {
        this.isLoading = false;
        this.submitted = true;
      }
    });
  }
}